// Stable per-browser session id, persisted in localStorage so the BE can
// dedup tracking events for anonymous (or even authenticated) users
// across page reloads. Generated lazily on first read.

import { Storage } from '../../../../constants/storage';

const STORAGE_KEY = Storage.insights_session_id;

function generateId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return `s-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export function getInsightsSessionId() {
    try {
        const existing = window.localStorage.getItem(STORAGE_KEY);
        if (existing) return existing;
        const next = generateId();
        window.localStorage.setItem(STORAGE_KEY, next);
        return next;
    } catch {
        return generateId();
    }
}
